/* eslint-disable indent */
import React from 'react';

import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { defaultGraphConfig, generateLabels } from 'utils/graphs';
import {
  AvgMaxCountAccess,
  PerformanceOperationalTimeGraphFields,
} from 'modules/environments/interfaces';
import { roundToFixedTwo } from 'utils/helpers';

interface OperationalTimeGraphProps {
  filter: AvgMaxCountAccess | string;
  environmentPerformanceOperationalTime: PerformanceOperationalTimeGraphFields;
}

const OperationalTimeGraph = ({
  filter,
  environmentPerformanceOperationalTime,
}: OperationalTimeGraphProps) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);
  const labels = generateLabels(environmentPerformanceOperationalTime?.metrics);

  const config = defaultGraphConfig({
    labels,
    datasets: [
      {
        data: environmentPerformanceOperationalTime?.metrics?.map(
          filter === 'avg'
            ? item => roundToFixedTwo(item?.operational_time?.avg)
            : item => roundToFixedTwo(item?.operational_time?.max)
        ),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
    ],
  });

  config.options.scales.xAxes[0].ticks.display = true;
  config.options.scales.yAxes[0].ticks.display = true;

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentPerformanceOperationalTime },
}: ApplicationState) => ({
  environmentPerformanceOperationalTime,
});
export default connect(mapStateToProps, {})(OperationalTimeGraph);
